var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"atom-gauge",attrs:{"aria-hidden":"true","fill":_vm.computedColor,"width":"100","height":"4"}},[_c('rect',{attrs:{"width":_vm.filled + '%',"height":"100%","rx":"2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }